module.exports = __webpack_public_path__ + "img/green_check.0f182ee4.png";